import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('selectPartField');

    return {
        PART: t('part'),
        PART_IS_REQUIRED: t('partIsRequired')
    };
};

export default useTranslation;
